import { createContext, useContext } from "react";

const InvoiceDataContext = createContext();

const useInvoiceData = () => useContext(InvoiceDataContext);

export { InvoiceDataContext, useInvoiceData };